import { TRPCClientError } from "@trpc/client";

/**
 * Error classification for tRPC queries, shared by the QueryClient's retry and
 * toast policies.
 */

/**
 * Client errors (auth, permissions, validation, not found) are never worth
 * retrying — retrying them only delays the error UI by several seconds.
 */
export function shouldRetry(failureCount: number, error: unknown) {
	if (error instanceof TRPCClientError) {
		const status = error.data?.httpStatus;
		if (typeof status === "number" && status >= 400 && status < 500) {
			return false;
		}
	}
	return failureCount < 2;
}

/**
 * Losing the session isn't something to shout about. Signing out clears the
 * cache while protected pages are still mounted, so their queries refetch
 * without a cookie and come back 401 — the route guard is already redirecting
 * to the login page, and a "Authentication required" toast would just follow
 * the user there. Same for a session that expires mid-visit.
 */
export function isAuthError(error: unknown) {
	if (!(error instanceof TRPCClientError)) return false;
	const status = error.data?.httpStatus;
	return status === 401 || status === 403;
}
